import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS } from '../../utils/handler';
import { DASHBOARD_URLS } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET } = HTTP_METHODS;
const { DASHBOARD, DASHBOARD_CHART } = DASHBOARD_URLS;

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: (params) => ({
        url: DASHBOARD,
        method: GET,
        ...(params?.isOurUser !== undefined && { params }) // only if params exist
      }),
      keepUnusedDataFor: 0
    }),

    getDashboardChart: builder.query({
      query: (params) => ({
        url: DASHBOARD_CHART,
        method: GET,
        params
      }),
      keepUnusedDataFor: 0
    })
  })
});

export const {
  useGetDashboardDataQuery,
  useGetDashboardChartQuery,
  useLazyGetDashboardChartQuery
} = dashboardApi;
